import { render, staticRenderFns } from "./IconClock.vue?vue&type=template&id=2c7f5f6b&scoped=true"
import script from "./IconClock.vue?vue&type=script&lang=js"
export * from "./IconClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f5f6b",
  null
  
)

export default component.exports